/* eslint-disable no-unused-vars */
import PropTypes from 'prop-types';
import { matchPath, useNavigate } from 'react-router-dom';
import { Divider, List, ListSubheader } from '@material-ui/core';
import NavItem from './NavItem';
import { addTab } from "../store/tabSlice";
import { useDispatch } from "react-redux";

const renderNavItems = ({ depth = 0, items, pathname, drawerOpen, openMobile, dispatch, navigate }) => (
  <List disablePadding>
    {items.reduce(
      // eslint-disable-next-line no-use-before-define
      (acc, item) => reduceChildRoutes({
        acc,
        item,
        pathname,
        depth,
        drawerOpen,
        openMobile,
        dispatch,
        navigate 
      }), []
    )}
  </List>
);

const reduceChildRoutes = ({ acc, pathname, item, depth, drawerOpen, openMobile, dispatch, navigate }) => {
  const key = `${item.title}-${depth}`;
  const exactMatch = item.path ? !!matchPath({ path: item.path, end: true }, pathname) : false;

  const handleClick = () => {
    if (item.path) {
      // console.log("Ajout d'un onglet détecté :", item); // 🔍 Debug
      dispatch(addTab({ id: item.path, label: item.title, path: item.path }));
      navigate(item.path);
    }
  };

  if (item.children) {
    const partialMatch = item.path ? !!matchPath({ path: item.path, end: false }, pathname) : false;

    acc.push(
      <NavItem
        active={partialMatch}
        depth={depth}
        icon={item.icon}
        info={item.info}
        key={key}
        open={partialMatch}
        path={item.path}
        title={item.title}
        drawerOpen={drawerOpen}
        openMobile={openMobile}
        onClick={handleClick} // Ajout du clic
      >
        {renderNavItems({
          depth: depth + 1,
          items: item.children,
          pathname,
          drawerOpen,
          openMobile,
          dispatch,
          navigate
        })}
      </NavItem>
    );
  } else {
    acc.push(
      <NavItem
        active={exactMatch}
        depth={depth}
        icon={item.icon}
        info={item.info}
        key={key}
        path={item.path}
        title={item.title}
        drawerOpen={drawerOpen}
        openMobile={openMobile}
        onClick={handleClick} // Ajout du clic
      />
    );
  }

  return acc;
};


const NavSection = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { items, pathname, title, drawerOpen, openMobile, ...other } = props;
  return (
    <List
      subheader={
      (drawerOpen || openMobile) ? (
        <ListSubheader
          disableGutters
          disableSticky
          sx={{
            color: 'menu.secondary',
            fontSize: '0.65rem',
            lineHeight: 2.5,
            fontWeight: 800,
            textTransform: 'uppercase',
            letterSpacing: '1.2px',
            px: 2,
            mb: 1,
            opacity: 0.7,
          }}
        >
          {title}
        </ListSubheader>
      ) : (
        <Divider sx={{ my: 1, mx: 2, borderColor: 'rgba(255,255,255,0.1)' }} />
      )
    }
      {...other}
    >
      {renderNavItems({
        items,
        pathname,
        drawerOpen,
        openMobile,
        dispatch,
        navigate
      })}
    </List>
  );
};

NavSection.propTypes = {
  items: PropTypes.array,
  pathname: PropTypes.string,
  title: PropTypes.string,
  drawerOpen: PropTypes.bool,
  openMobile: PropTypes.bool
};

export default NavSection;
